import { render, staticRenderFns } from "./RPTrade.vue?vue&type=template&id=2313cd18"
import script from "./RPTrade.vue?vue&type=script&lang=js"
export * from "./RPTrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports